import { render, staticRenderFns } from "./InputCpfPassaporte.vue?vue&type=template&id=34b83395&scoped=true&"
import script from "./InputCpfPassaporte.vue?vue&type=script&lang=js&"
export * from "./InputCpfPassaporte.vue?vue&type=script&lang=js&"
import style0 from "./InputCpfPassaporte.vue?vue&type=style&index=0&id=34b83395&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b83395",
  null
  
)

export default component.exports